"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** mixins */
var _default = exports.default = {
  name: 'Enote',
  mixins: [_dialog.default],
  data: function data() {
    return {
      planTaskInfoPk: '',
      enoteList: []
    };
  },
  computed: {
    sasToken: function sasToken() {
      return this.$store.getters.sasToken;
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    // 监听弹窗打开
    isShowModel: function isShowModel(newVal) {
      if (newVal) {
        console.log('open enote');
      }
    }
  },
  methods: {
    // open dialog init
    init: function init(planTaskInfoPk) {
      this.planTaskInfoPk = planTaskInfoPk;
      this.enoteList = [];
      this.isShowModel = true;
      this.getNote();
    },
    getNote: function getNote() {
      var _this = this;
      this.isLoading = true;
      var params = {
        planTaskInfoPk: this.planTaskInfoPk
        // planTaskInfoPk: '33339004582887424'
      };
      this.$api.enote.getNote(params).then(function (res) {
        _this.isLoading = false;
        if (res.success && res.data) {
          _this.enoteList = JSON.parse(res.data);
        } else {
          _this.enoteList = [];
        }
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    }
  }
};